import { registerEnumType } from 'type-graphql'

export enum UnitOfMeasureCategoryEnum {
  LENGTH = 'LENGTH',
  WEIGHT = 'WEIGHT',
  VOLUME = 'VOLUME',
  COUNT = 'COUNT',
  AREA = 'AREA',
  TIME = 'TIME',
}

registerEnumType(UnitOfMeasureCategoryEnum, { name: 'UnitOfMeasureCategoryEnum', description: 'Unit of measure category' })
